<script lang="ts">
  import { t } from './i18n.svelte'
  import type { ShareMode, StartupStage } from './tauri'

  let { stage, share }: { stage: StartupStage; share: ShareMode } = $props()
  const steps = $derived<StartupStage[]>(
    share === 'server'
      ? ['opening_room', 'starting_video']
      : ['preparing_link', 'opening_room', 'starting_video'],
  )
  const current = $derived(steps.indexOf(stage))
  const labels: Record<StartupStage, string> = {
    preparing_link: 'Creating invite link…',
    opening_room: 'Opening room…',
    starting_video: 'Preparing video…',
  }
</script>

<div class="startup" role="status" aria-live="polite" aria-atomic="true">
  <div class="startup__label">
    <strong>{t(labels[stage])}</strong>
    <span>{t('Step {n} of {total}', { n: current + 1, total: steps.length })}</span>
  </div>
  <div class="startup__track" aria-hidden="true">
    {#each steps as step, index (step)}
      <span class:done={index < current} class:current={index === current}></span>
    {/each}
  </div>
</div>

<style>
  .startup {
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    padding: 14px 24px;
    background: var(--bg);
    border-top: 1px solid var(--border);
  }

  .startup__label {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 8px;
    font-size: 13px;
  }

  .startup__label span {
    color: var(--text-dim);
  }

  .startup__track {
    display: flex;
    gap: 6px;
  }

  .startup__track span {
    flex: 1;
    height: 4px;
    border-radius: 4px;
    background: var(--bg-sunken);
  }

  .startup__track .done,
  .startup__track .current {
    background: var(--accent);
  }

  .startup__track .current {
    animation: waiting 1.2s ease-in-out infinite;
  }

  @keyframes waiting {
    50% {
      opacity: 0.35;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .startup__track .current {
      animation: none;
    }
  }
</style>
